import { combineClassnames } from 'app/common/presentation'

import styles from './Avatar.module.scss'

interface AvatarProps {
  className?: string
  initials: string
  showNotification?: boolean
}
const Avatar = ({ className, initials, showNotification = false }: AvatarProps) => {
  return (
    <div className={combineClassnames(styles.avatar, className)} data-testid="avatar">
      {showNotification && <div className={styles.notification} data-testid="notification"></div>}
      <div className={styles.initials}>{initials}</div>
    </div>
  )
}

export default Avatar
